import { DefaultSearchOptionsType } from 'src/hooks/table/useTableColumns';

export enum CaseSearchOptionValues {
  CASE_ID = 'Case.id',
  CASE_NAME = 'Case.name',
  CASE_LEAD = 'CaseLead.name',
  CASE_CATEGORY = 'Categories.locales',
  CASE_STATUS = 'Case.status',
  CASE_TAG_NAME = 'CaseTags.name',
  CASE_TAG_TYPE = 'CaseTags.TagType.name',
  REPORT_USER_NAME = 'CaseHasUsers.User.name',
}

export enum CaseSearchOptionLabels {
  CASE_ID = 'Search By Case ID',
  CASE_NAME = 'Search By Case Name',
  CASE_LEAD = 'Search By Case Lead',
  CASE_CATEGORY = 'Search By Category',
  CASE_STATUS = 'Search By Case Status',
  CASE_TAG_NAME = 'Search by Case Tag',
  CASE_TAG_TYPE = 'Search by Case Tag Type',
  REPORT_USER_NAME = 'Search by Case Team Members',
}

export enum CaseSearchableFields {
  CASE_ID = 'caseId',
  CASE_LEAD = 'caseLead',
  CASE_NAME = 'caseName',
  CASE_CATEGORY = 'caseCategory',
  CASE_STATUS = 'caseStatus',
  CASE_TAG_NAME = 'caseTagName',
  CASE_TAG_TYPE = 'caseTagType',
  REPORT_USER_NAME = 'reportUsername',
}

export const caseSearchOptions: DefaultSearchOptionsType[] = [
  {
    value: CaseSearchOptionValues.CASE_ID,
    label: CaseSearchOptionLabels.CASE_ID,
  },
  {
    value: CaseSearchOptionValues.CASE_NAME,
    label: CaseSearchOptionLabels.CASE_NAME,
  },
  {
    value: CaseSearchOptionValues.CASE_LEAD,
    label: CaseSearchOptionLabels.CASE_LEAD,
  },
  {
    value: CaseSearchOptionValues.CASE_CATEGORY,
    label: CaseSearchOptionLabels.CASE_CATEGORY,
  },
  {
    value: CaseSearchOptionValues.CASE_STATUS,
    label: CaseSearchOptionLabels.CASE_STATUS,
  },
  {
    value: CaseSearchOptionValues.REPORT_USER_NAME,
    label: CaseSearchOptionLabels.REPORT_USER_NAME,
  },
  {
    value: CaseSearchOptionValues.CASE_TAG_NAME,
    label: CaseSearchOptionLabels.CASE_TAG_NAME,
  },
  {
    value: CaseSearchOptionValues.CASE_TAG_TYPE,
    label: CaseSearchOptionLabels.CASE_TAG_TYPE,
  },
];

export const mapParamsToDefaultSearchOptions: {
  [key in CaseSearchableFields]: DefaultSearchOptionsType;
} = {
  [CaseSearchableFields.CASE_ID]: {
    value: CaseSearchOptionValues.CASE_ID,
    label: CaseSearchOptionLabels.CASE_ID,
  },
  [CaseSearchableFields.CASE_NAME]: {
    value: CaseSearchOptionValues.CASE_NAME,
    label: CaseSearchOptionLabels.CASE_NAME,
  },
  [CaseSearchableFields.CASE_LEAD]: {
    value: CaseSearchOptionValues.CASE_LEAD,
    label: CaseSearchOptionLabels.CASE_LEAD,
  },
  [CaseSearchableFields.CASE_CATEGORY]: {
    value: CaseSearchOptionValues.CASE_CATEGORY,
    label: CaseSearchOptionLabels.CASE_CATEGORY,
  },
  [CaseSearchableFields.CASE_STATUS]: {
    value: CaseSearchOptionValues.CASE_STATUS,
    label: CaseSearchOptionLabels.CASE_STATUS,
  },
  [CaseSearchableFields.REPORT_USER_NAME]: {
    value: CaseSearchOptionValues.REPORT_USER_NAME,
    label: CaseSearchOptionLabels.REPORT_USER_NAME,
  },
  [CaseSearchableFields.CASE_TAG_NAME]: {
    value: CaseSearchOptionValues.CASE_TAG_NAME,
    label: CaseSearchOptionLabels.CASE_TAG_NAME,
  },
  [CaseSearchableFields.CASE_TAG_TYPE]: {
    value: CaseSearchOptionValues.CASE_TAG_TYPE,
    label: CaseSearchOptionLabels.CASE_TAG_TYPE,
  },
};

export const mapOptionsToParamKeys = {
  [CaseSearchOptionValues.CASE_ID]: CaseSearchableFields.CASE_ID,
  [CaseSearchOptionValues.CASE_NAME]: CaseSearchableFields.CASE_NAME,
  [CaseSearchOptionValues.CASE_LEAD]: CaseSearchableFields.CASE_LEAD,
  [CaseSearchOptionValues.CASE_CATEGORY]: CaseSearchableFields.CASE_CATEGORY,
  [CaseSearchOptionValues.CASE_STATUS]: CaseSearchableFields.CASE_STATUS,
  [CaseSearchOptionValues.CASE_TAG_NAME]: CaseSearchableFields.CASE_TAG_NAME,
  [CaseSearchOptionValues.CASE_TAG_TYPE]: CaseSearchableFields.CASE_TAG_TYPE,
  [CaseSearchOptionValues.REPORT_USER_NAME]:
    CaseSearchableFields.REPORT_USER_NAME,
};
